module.exports = __webpack_public_path__ + "img/Orange_logo.ce02be5e.svg";